//ONBOARDING
export const ONBOARDING_STARTED = "Onboarding Started";
export const ONBOARDING_KR_EMAIL_ENTERED = "Onboarding KR Email Entered";
export const ONBOARDING_KR_EMAIL_VERIFIED = "Onboarding KR Email Verified";
export const ONBOARDING_KR_SIGNUP = "Onboarding KR Sign Up";
export const ACCOUNT_CREATION_TYPE_SELECTED = "Account Creation Type Selected";
export const ONBOARDING_NEW_USER_INFO_ENTERED = "Onboarding New User Info Entered";
export const ONBOARDING_INFO_ENTERED_SUCCESS = "Onboarding Info Entered Success";
export const ONBOARDING_INFO_ENTERED_FAILED = "Onboarding Info Entered Failed";
export const KFORB_ONBOARDING_PASSWORD_VERIFIED = "KforB Onboarding Password Verified";
export const BUSINESS_TYPE_VERIFIED = "Business Type Verified";
export const BUSINESS_DOCUMENTS_UPLOADED = "Business Documents Uploaded";
export const BUSINESS_INFO_ENTERED = "Business Info Entered";
export const KFORB_ACCOUNT_ADDRESS_VERIFICATION_STARTED =
    "KforB Account Address Verification Started";
export const KFORB_ACCOUNT_SUBMITTED = "KforB Account Submitted";
export const ADD_USER_STARTED = "Add User Started";
export const ADD_USER_FAILED = "Add User Failed";
export const USER_INVITE_COMPLETED = "User Invite Completed";
export const USER_INVITE_FAILED = "User Invite Failed";
export const EDIT_USER_STARTED = "Edit User Started";
export const EDIT_USER_COMPLETED = "Edit User Completed";
export const EDIT_USER_FAILED = "Edit User Failed";
export const DELETE_USER_STARTED = "Delete User Started";
export const DELETE_USER_COMPLETED = "Delete User Completed";
export const DELETE_USER_FAILED = "Delete User Failed";
export const LOGIN = "Login";
export const LOGIN_FAILED = "Login Failed";
export const LOGIN_BUSINESS_PROFILE_SELECTED = "Login Business Profile Selected";
export const TRANSACTION_PIN_CREATED = "Transaction Pin Created";
export const TRANSACTION_PIN_UPDATED = "Transaction Pin Updated";
export const TRANSACTION_PIN_RESET = "Transaction Pin Reset";
export const KFORB_USER_ADDRESS_VERIFICATION_STARTED = "KforB User Address Verification Started";

//CARDS
export const DEBIT_CARD_BLOCKED = "Debit Card Blocked";
export const DEBIT_CARD_UNBLOCKED = "Debit Card Unblocked";
export const DEBIT_CARD_CANCELLED = "Debit Card Cancelled";
export const DEBIT_CARD_REQUEST_STARTED = "Debit Card Request Started";
export const DEBIT_CARD_ADDRESS_ENTERED = "Debit Card Address Entered";
export const DEBIT_CARD_REQUESTED = "Debit Card Requested";
export const DEBIT_CARD_VERIFICATION_STARTED = "Debit Card Verification Started";
export const DEBIT_CARD_VERIFICATION_FAILED = "Debit Card Verification Failed";
export const DEBIT_CARD_VERIFICATION_SUCCESS = "Debit Card Verification Success";
export const EXPENSE_CARD_REQUEST_STARTED = "Expense Card Request Started";
export const EXPENSE_CARD_REQUESTED = "Expense Card Requested";

//PAYMENTS
export const TRANSACTION_STARTED = "Transaction Started";
export const TRANSACTION_SUCCESS = "Transaction Success";
export const TRANSACTION_FAILED = "Transaction Failed";
export const SET_EXPENSE_CATEGORY = "Set Expense Category";
export const BANK_TRANSFER_TILE_CLICKED = "Bank Transfer Tile Clicked";
export const BANK_TRANSFER_STARTED = "Bank Transfer Started";
export const BANK_TRANSFER_SUCCESS = "Bank Transfer Success";
export const BANK_TRANSFER_FAILED = "Bank Transfer Failed";
export const BANK_TRANSFER_DETAILS_ENTERED = "Bank Transfer Details Entered";
export const TRANSACTION_REQUEST_MADE = "Transaction Request Made";
export const TRANSACTION_REQUEST_APPROVED = "Transaction Request Approved";
export const TRANSACTION_REQUEST_REJECTED = "Transaction Request Rejected";
export const TRANSACTION_APPROVAL_REQUEST = "Transaction Approval Request ";
export const INTERNAL_TRANSFER = "Internal Transfer";
//BULKPAYMENTS
export const MULTIPLE_TRANSFER_STARTED = "Multiple Transfer Started";
export const MULTIPLE_TRANSFER_SUCCESS = "Multiple Transfer Success";
export const MULTIPLE_TRANSFER_FAILED = "Multiple Transfer Failed";
//SCHEDULE PAYMENTS
export const SCHEDULE_PAYMENT_TRANSACTION_STARTED = "Scheduled Payment Transaction Started";
export const SCHEDULE_PAYMENT_TRANSACTION_SUCCESS = "Scheduled Payment Transaction Success";
export const SCHEDULE_PAYMENT_TRANSACTION_FAILED = "Scheduled Payment Transaction Failed";
//AIRTIME
export const AIRTIME_TRANSACTION_TILE_CLICKED = "Airtime Transaction Tile Clicked";
export const AIRTIME_TRANSACTION_STARTED = "Airtime Transaction Started";
export const AIRTIME_TRANSACTION_SUCCESS = "Airtime Transaction Success";
export const AIRTIME_TRANSACTION_FAILED = "Airtime Transaction Failed";
//BILL PAYMENT
export const BILL_PAYMENT_STARTED = "Bill Payment Started";
export const BILL_PAYMENT_SUCCESS = "Bill Payment Success";
export const BILL_PAYMENT_FAILED = "Bill Payment Failed";
export const BILL_PAYMENT_TILE_CLICKED = "Bill Payment Tile Clicked";
// ADD MONEY
export const ADD_MONEY_STARTED = "Add Money Started";
export const ADD_MONEY_SUCCESS = "Add Money Success";
export const ADD_MONEY_FAILED = "Add Money Failed";

//NEW TO BANK
export const ONBOARDING_EMAIL_ENTERED = "Onboarding Email Entered";
export const ONBOARDING_EMAIL_VERIFIED = "Onboarding New User Email Verified";

export const NEW_USER_IDENTIFICATION_STARTED = "New User Identification Started";
export const NEW_USER_VERIFY_IDENTITY_SUBMITTED = "New User Verify Identity Submitted";
export const NEW_USER_UPLOAD_VALID_ID_SUBMITTED = "New User Upload Valid ID Submitted";
export const NEW_USER_MORE_ABOUT_YOUR_BUSINESS = "New User More About your Business";
export const NEW_USER_IDENTIFICATION_COMPLETE = "New User Identification Complete";

export const ONBOARDING_MOBILE_VERIFIED = "Onboarding New User Mobile Verified";
export const REGISTRATION_COMPLETED = "Registration Completed";
export const K4B_NEW_CUSTOMER_CHECKLIST = "K4B New Customer Checklist";
export const ONBOARDING_BVN_ENTERED = "Onboarding BVN Entered";
export const ONBOARDING_BVN_VERIFIED = "Onboarding BVN Verified";
export const ONBOARDING_BVN_FAILED = "Onboarding BVN Failed";
export const IDENTITY_VERIFICATION_SELFIE_CLICKED = "Identity Verification Selfie Clicked";
export const IDENTITY_DOCUMENT_STARTED = "Identity Document Started";
export const ACCOUNT_TYPE_SELECTED = "Account Type Selected";
export const FREELANCER_CHECKLIST = "Freelancer Checklist";
export const BUSINESS_ACCOUNT_CHECKLIST = "Business Account Checklist";
export const CERTIFICATE_OF_INCORPORATION = "Certificate of Incorporation";
export const BUSINESS_INFORMATION = "Business Information";
export const CAC_INFORMATION_SUBMITTED = "CAC Information Submitted";
export const TIN_INFORMATION_SUBMITTED = "Tin Information Submitted";

export const BUSINESS_ACCOUNT_OPENING_STARTED = "Full Business Account Opening Started";
export const BUSINESS_INFORMATION_SUBMITTED =
    "Full Business Account Opening - Business Information Submitted";
export const ADDITIONAL_DOCUMENTS_SUBMITTED =
    "Full Business Account Opening - Additional Documents Submitted ";
export const MORE_ABOUT_YOUR_BUSINESS_SUBMITTED =
    "Full Business Account Opening - More About Your Business Complete";
export const BUSINESS_OWNER_SUBMITTED =
    "Full Business Account Opening - Ownership of Business Submitted";
export const BUSINESS_KYB_SUBMITTED = "Full Business Account Opening - Complete Submit";
export const BUSINESS_ACCOUNT_TYPE_CHOSEN = "Business Account Opening Type Chosen";
export const BUSINESS_ACCOUNT_OPENING_SELECTED =
    "Full Business Account Opening - Account Admin Selected";
export const BUSINESS_ACCOUNT_OPENING_DIRECTORS_SUBMITTED =
    "Full Business Account Opening - Directors Consent Submit";
export const BUSINESS_ACCOUNT_OPENING_SUBMISSION_COMPLETE =
    "Full Business Account Opening - Submission Complete";
export const FREELANCER_ACCOUNT_OPENING_SUMBITTED = "Freelancer Account Opening - Complete Submit";

export const MORE_ABOUT_YOUR_BUSINESS = "More About Your Business";
export const MORE_ABOUT_YOUR_BUSINESS_FAILED = "More About Your Business Failed";
export const ADDITIONAL_DOCUMENTS = "Additional Documents";
export const BUSINESS_OWNER = "Tax Information";
export const BUSINESS_OWNER_SUBMITTED_FAILED = "Business Owner Submitted Failed";
export const LOGIN_ACCOUNT_SELECTED = "Login Account Selected";
export const VIEW_DASHBOARD = "View Dashboard";

// INVOICE
export const INVOICE_STARTED = "Invoice Started";
export const INVOICE_CREATED = "Invoice Created";
export const INVOICE_SENT = "Invoice Sent";

// Business Reg
export const BUSINESS_REG_TILE_CLICKED = "Business Reg Tile Clicked";
export const BUSINESS_REG_STARTED = "Business Reg Started";
export const BUSINESS_REG_TYPE_SELECTED = "Business Reg Business Type Selected";
export const BUSINESS_REG_BUSINESS_INFO_SUBMITTED = "Business Reg Business Info Submitted";
export const BUSINESS_REG_OWNER_INFO_SUBMITTED = "Business Reg Owner Info Submitted";

export const BUSINESS_REG_APPLICATION_SUBMITTED = "Business Reg Application Submitted";
export const BUSINESS_REG_PAYMENT_SUCCESS = "Business Reg Payment Success";
export const BUSINESS_REG_PAYMENT_FAILED = "Business Reg Payment Failed";
export const BUSINESS_REG_COMPLETED = "Business Reg Completed";

// SUB ACCOUNT
export const SUB_ACCOUNT_CREATION_STARTED = "Sub Account Creation Started";
export const SUB_ACCOUNT_NAME_ENTERED = "Sub Account Name Entered";
export const SUB_ACCOUNT_CREATED = "Sub Account Created";

// PAYROLL
export const PAYROLL_TILE_CLICKED = "Payroll Tile Clicked";
export const PAYROLL_STARTED = "Payroll Started";
export const PAYROLL_FREQUENCY_COMPLETE = "Payroll Frequency Complete";
export const PAYROLL_SETTING_COMPLETE = "Payroll Settings Complete";
export const PAYROLL_EMPLOYEE_ADDED = "Payroll Employees Added";
export const PAYROLL_SET_UP = "Payroll Set Up";
export const PAYROLL_SCHEDULE_SET_UP = "Pay Schedule Set up";
export const PAYROLL_FREQUENCY_SETTINGS_UPDATE = "Payroll Frequency-Settings Updated";

// PAYROLL WITH BENTO
export const PAYROLL_WITH_BENTO_CLICKED = "Payroll with Bento Clicked";
export const PAYROLL_WITH_BENTO_CONNECTION_STARTED = "Payroll with Bento Connection Started";
export const PAYROLL_WITH_BENTO_CONNECTION_COMPLETE = "Payroll with Bento Connection Complete";

// POS
export const CHOOSE_POS_REQUEST_TYPE = "Chooses POS Request Type";
export const POS_TILE_CLICKED = "POS Tile Clicked";
export const TERMINAL_POS_REQUEST_STARTED = "Terminal POS Request Started";
export const TERMINAL_POS_MERCHANT_ENTERED = "Terminal POS Merchant Details Entered";
export const TERMINAL_POS_DELIVERY_DETAILS = "Terminal POS Delivery Details";
export const TERMINAL_POS_ORDER_COMPLETE = "Terminal POS Order Complete";
export const TERMINAL_POS_ACTIVATION_STARTED = "Terminal POS Activation Started";
export const TERMINAL_POS_ACTIVATION_COMPLETE = "Terminal POS Activation Complete";
export const TERMINAL_POS_ACTIVATION_FAILED = "Terminal POS Activation Failed";
export const VIRTUAL_POS_ACCOUNT_CREATED = "Virtual POS Account Created";

//CATALOGUE
export const CATALOGUE_TILE_CLICKED = "Catalogue Tile Clicked";
export const CATALOGUE_ONBOARDING_STARTED = "Catalogue Onboarding Started";
export const CATALOGUE_ITEM_CREATED = "Catalogue Item Created";
export const CATALOGUE_POS_DEVICE_ADDED = "Catalogue POS Device Added";
// export const CATALOGUE_SALES_MODE_ITEMS = 'Catalogue Sales Mode Items';
// export const CATALOGUE_ITEM_PUSHED_TO_POS ='Catalogue Item Pushed to POS';

// HOME ADDRESS
export const ADDRESS_UPDATE_STARTED = "Address Update Started";
export const ADDRESS_UPDATE_SUBMITTED = "Address Update Submitted";

//PASSKEY
export const PASSKEY_SETUP_COMPLETE = "Passkey Set Up Complete";
export const PASSKEY_SETUP_FAILED = "Passkey Set Up Failed";

// PERKS
export const PERK_CHOSEN = "Perk Chosen";
